import axios from 'axios';
import { SupplierBillingAddressModel } from '../models/SupplierBillingAddressModel';

const API_URL = process.env.REACT_APP_API_URL;
const BILLING_ADDRESSES_URL = `${API_URL}/api/b2b/supplier-billing-addresses/`;

export function listSupplierBillingAddresses(
  supplierId: number
): Promise<{ data: Array<SupplierBillingAddressModel> }> {
  return axios.get(BILLING_ADDRESSES_URL, {
    params: { supplier: supplierId, state: 'active' },
  });
}

export function retrieveSupplierBillingAddress(
  id: number
): Promise<{ data: SupplierBillingAddressModel }> {
  return axios.get(`${BILLING_ADDRESSES_URL}${id}/`);
}

export function createSupplierBillingAddress(
  address: SupplierBillingAddressModel
): Promise<{ data: SupplierBillingAddressModel }> {
  return axios.post(BILLING_ADDRESSES_URL, address);
}

export function updateSupplierBillingAddress(
  address: SupplierBillingAddressModel
): Promise<{ data: SupplierBillingAddressModel }> {
  return axios.patch(`${BILLING_ADDRESSES_URL}${address.id}/`, address);
}
